import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: var(--space-400) var(--space-500);
  background-color: var(--bg-brand);
  color: var(--text-on-brand);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  border-radius: var(--radius-brand);

  &:hover {
    background-color: var(--bg-brand-hover);
  }
`

export const Body = styled.div`
  display: flex;

  & > * + * {
    margin-left: var(--space-300);
  }
`

export const ActionLabelContainer = styled.div`
  display: flex;

  & > * + * {
    margin-left: var(--space-300);
  }
`
